// MainContent.js
import styled from 'styled-components';
import { mobile } from '../../responsive';

const MainContent = styled.div`
  padding-top: var(--lusuku-nav-h, 116px);
  max-width: 100vw;
  overflow-x: hidden;
    ${mobile({
      paddingTop: "var(--lusuku-nav-h, 120px)"
    })}
`;

export default MainContent;
